/* ░░ SOLAR — Virtual Try-On (motor reutilizable + quick try-on) ░░
   Seguimiento facial (MediaPipe FaceLandmarker) + overlay. 100% en el dispositivo. */
import { FaceLandmarker, FilesetResolver } from "https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.18";

const P = (window.SOLAR_PRODUCTS || []);
const $ = (s, c = document) => c.querySelector(s);
const $$ = (s, c = document) => [...c.querySelectorAll(s)];
const clp = (n) => '$' + Number(n).toLocaleString('es-CL');

/* ── ENGINE ── */
const TUNE = { widthFactor: 1.95, yOffset: 0.018 };
let landmarker = null, running = false, last = -1, A = null;
const glassCache = {};
function getGlass(prod) {
  return new Promise(res => {
    if (glassCache[prod.id]) return res(glassCache[prod.id]);
    const img = new Image(); img.crossOrigin = 'anonymous';
    img.onload = () => { glassCache[prod.id] = removeWhite(img); res(glassCache[prod.id]); };
    img.onerror = () => res(null); img.src = prod.img;
  });
}
async function ensureModel() {
  if (landmarker) return;
  const fs = await FilesetResolver.forVisionTasks("https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.18/wasm");
  landmarker = await FaceLandmarker.createFromOptions(fs, {
    baseOptions: { modelAssetPath: "https://storage.googleapis.com/mediapipe-models/face_landmarker/face_landmarker/float16/1/face_landmarker.task", delegate: "GPU" },
    runningMode: "VIDEO", numFaces: 1
  });
}
async function startTryOn(target, prod) {
  stopTryOn();
  A = { ...target, ctx: target.canvas.getContext('2d'), glass: null, label: prod.title };
  if (A.status) A.status.textContent = 'CARGANDO MOTOR…';
  if (A.onPrep) A.onPrep();
  try {
    await ensureModel();
    A.glass = await getGlass(prod);
    const stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: 'user', width: { ideal: 1280 } }, audio: false });
    A.video.srcObject = stream; await A.video.play();
    running = true; if (A.onLive) A.onLive();
    if (A.status) A.status.textContent = 'BUSCANDO ROSTRO…';
    requestAnimationFrame(loop);
  } catch (e) { console.error(e); if (A.status) A.status.textContent = 'NO SE PUDO ABRIR LA CÁMARA'; if (A.onFail) A.onFail(); }
}
function stopTryOn() {
  running = false;
  if (A) { const s = A.video.srcObject; if (s) s.getTracks().forEach(t => t.stop()); A.video.srcObject = null; if (A.ctx) A.ctx.clearRect(0, 0, A.canvas.width, A.canvas.height); if (A.onStop) A.onStop(); }
}
function setGlassLive(prod) { // cambiar modelo con cámara abierta
  if (A) { A.label = prod.title; getGlass(prod).then(g => { if (A) A.glass = g; }); }
}
function loop() {
  if (!running || !A) return;
  const v = A.video, cv = A.canvas, ctx = A.ctx, w = v.videoWidth, h = v.videoHeight;
  if (w && h) {
    if (cv.width !== w) { cv.width = w; cv.height = h; }
    ctx.clearRect(0, 0, w, h);
    const now = performance.now(); let res = null;
    if (now !== last) { last = now; try { res = landmarker.detectForVideo(v, now); } catch (e) {} }
    if (res && res.faceLandmarks && res.faceLandmarks.length) { if (A.status) A.status.textContent = '● EN VIVO · ' + A.label; draw(ctx, res.faceLandmarks[0], w, h, A.glass); }
    else if (A.status) A.status.textContent = 'BUSCANDO ROSTRO…';
  }
  requestAnimationFrame(loop);
}
function draw(ctx, lm, w, h, glass) {
  if (!glass) return;
  const px = q => ({ x: q.x * w, y: q.y * h });
  const a = px(lm[33]), b = px(lm[263]), ci = px(lm[133]), cj = px(lm[362]);
  const eyeDist = Math.hypot(b.x - a.x, b.y - a.y), angle = Math.atan2(b.y - a.y, b.x - a.x);
  const cx = (a.x + b.x + ci.x + cj.x) / 4, cy = (a.y + b.y + ci.y + cj.y) / 4 + h * TUNE.yOffset;
  const iw = glass.naturalWidth || glass.width, ih = glass.naturalHeight || glass.height;
  const gw = eyeDist * TUNE.widthFactor, gh = gw * ((ih / iw) || .4);
  ctx.save(); ctx.translate(cx, cy); ctx.rotate(angle); ctx.globalAlpha = .98;
  ctx.drawImage(glass, -gw / 2, -gh / 2, gw, gh); ctx.restore();
}
function removeWhite(img) {
  const c = document.createElement('canvas'); c.width = img.naturalWidth; c.height = img.naturalHeight;
  const x = c.getContext('2d'); x.drawImage(img, 0, 0);
  let minX = c.width, minY = c.height, maxX = 0, maxY = 0, found = false;
  try {
    const d = x.getImageData(0, 0, c.width, c.height), a = d.data, W = c.width;
    for (let i = 0; i < a.length; i += 4) {
      const r = a[i], g = a[i + 1], b = a[i + 2], m = Math.min(r, g, b);
      if (r > 238 && g > 238 && b > 238) a[i + 3] = 0; else if (m > 224) a[i + 3] = Math.max(0, (255 - m) * 6);
      if (a[i + 3] > 18) { const idx = i / 4, X = idx % W, Y = (idx / W) | 0; if (X < minX) minX = X; if (X > maxX) maxX = X; if (Y < minY) minY = Y; if (Y > maxY) maxY = Y; found = true; }
    }
    x.putImageData(d, 0, 0);
  } catch (e) { return img; }
  if (!found) return c;
  const cw = maxX - minX + 1, ch = maxY - minY + 1, o = document.createElement('canvas'); o.width = cw; o.height = ch;
  o.getContext('2d').drawImage(c, minX, minY, cw, ch, 0, 0, cw, ch); return o;
}

/* ── MAIN TRY-ON (solo si existe la sección Virtual Try-On) ── */
const screen = $('#tryScreen');
if (screen) {
  const startBtn = $('#tryStart'), search = $('#trySearch'), picker = $('#tryPicker');
  let current = P[0];
  const tuneSize = $('#tuneSize'), tuneY = $('#tuneY');
  if (tuneSize) { tuneSize.value = TUNE.widthFactor; tuneSize.addEventListener('input', () => TUNE.widthFactor = +tuneSize.value); }
  if (tuneY) { tuneY.value = TUNE.yOffset; tuneY.addEventListener('input', () => TUNE.yOffset = +tuneY.value); }
  const mainTarget = {
    main: true, video: $('#tryVideo'), canvas: $('#tryCanvas'), status: $('#tryStatus'),
    onPrep: () => { startBtn.classList.add('hide'); },
    onLive: () => { screen.classList.add('scanning'); },
    onStop: () => { screen.classList.remove('scanning'); startBtn.classList.remove('hide'); $('#tryStatus').textContent = 'CÁMARA EN ESPERA'; },
    onFail: () => { startBtn.classList.remove('hide'); }
  };
  function buildPicker(filter = '') {
    const f = filter.trim().toLowerCase();
    const items = P.map((p, i) => ({ p, i })).filter(({ p }) => !f || p.title.toLowerCase().includes(f) || (p.gender || '').toLowerCase().includes(f));
    picker.innerHTML = items.map(({ p, i }) =>
      `<button type="button" class="tryon__thumb${p === current ? ' active' : ''}" data-i="${i}" title="${p.title}">
         <img src="${p.img}" alt="${p.title}" loading="lazy"/><span>${p.title.split(' ')[0]}</span>
       </button>`).join('') || '<p class="tryon__empty">Sin resultados…</p>';
    picker.querySelectorAll('.tryon__thumb').forEach(t => t.addEventListener('click', () => {
      picker.querySelectorAll('.tryon__thumb').forEach(x => x.classList.remove('active'));
      t.classList.add('active'); current = P[+t.dataset.i];
      if (running && A && A.main) setGlassLive(current);
    }));
  }
  buildPicker();
  if (search) search.addEventListener('input', () => buildPicker(search.value));
  getGlass(current);
  startBtn.addEventListener('click', () => startTryOn(mainTarget, current));
  new IntersectionObserver((es) => es.forEach(e => {
    if (!e.isIntersecting && running && A && A.main) stopTryOn();
  }), { threshold: 0.15 }).observe(screen);
}

/* ── QUICK TRY-ON (desde el carrito, sin salir) ── */
document.body.insertAdjacentHTML('beforeend', `
<div class="qv" id="qv" aria-hidden="true">
  <div class="qv__overlay" id="qvOverlay"></div>
  <div class="qv__panel" data-lenis-prevent>
    <button class="qv__close" id="qvClose" aria-label="Cerrar">✕</button>
    <div class="qv__stage" id="qvStage">
      <img id="qvImg" alt="">
      <button class="qv__nav qv__prev" id="qvPrev" aria-label="Anterior" hidden>‹</button>
      <button class="qv__nav qv__next" id="qvNext" aria-label="Siguiente" hidden>›</button>
      <span class="qv__count" id="qvCount" hidden></span>
      <video id="qvVid" playsinline muted></video><canvas id="qvCanvas"></canvas>
      <div class="pdp__hud" id="qvHud" hidden><span class="rec"></span> <span id="qvStat"></span></div>
      <button class="pdp__trybtn" id="qvTry"><span class="rec"></span> Probar con cámara</button>
      <div class="pdp__tune" id="qvTune" hidden>
        <label>Tamaño <input type="range" id="qvSize" min="1.3" max="2.6" step="0.02" value="1.95"></label>
        <label>Altura <input type="range" id="qvY" min="-0.06" max="0.08" step="0.004" value="0.018"></label>
        <button class="pdp__stop" id="qvStopBtn">Cerrar cámara</button>
      </div>
    </div>
    <div class="qv__info">
      <h3 id="qvName"></h3>
      <div class="qv__price" id="qvPrice"></div>
      <div class="qv__specs" id="qvSpecs"></div>
      <button class="btn btn--solid" id="qvAdd"></button>
      <p class="qv__hint">Desliza las fotos ‹ › o pruébatelos con tu cámara</p>
    </div>
  </div>
</div>`);
const qv = $('#qv');
const qvTarget = {
  video: $('#qvVid'), canvas: $('#qvCanvas'), status: $('#qvStat'),
  onPrep: () => { $('#qvHud').hidden = false; $('#qvTry').style.display = 'none'; },
  onLive: () => { $('#qvStage').classList.add('live'); $('#qvTune').hidden = false; },
  onStop: () => { $('#qvStage').classList.remove('live'); $('#qvTune').hidden = true; $('#qvHud').hidden = true; $('#qvTry').style.display = ''; },
  onFail: () => { $('#qvTry').style.display = ''; }
};
let qvProd = null, qvImgs = [], qvIdx = 0;
function showQvImg() {
  $('#qvImg').src = qvImgs[qvIdx];
  const multi = qvImgs.length > 1;
  $('#qvPrev').hidden = !multi; $('#qvNext').hidden = !multi;
  const cEl = $('#qvCount'); cEl.hidden = !multi; cEl.textContent = `${qvIdx + 1}/${qvImgs.length}`;
}
function openQuickView(prod) {
  qvProd = prod;
  qvImgs = (prod.images && prod.images.length ? prod.images : [prod.img]); qvIdx = 0; showQvImg();
  $('#qvName').textContent = prod.title;
  $('#qvPrice').innerHTML = prod.cheap ? `<b class="now">${clp(29990)}</b> <span class="qv__deal">últimas unidades</span>` : `<b>${clp(prod.price)}</b>`;
  $('#qvSpecs').innerHTML = [['Forma', prod.forma.join(', ')], ['Color', prod.colorMarco.join(', ')], ['Uso', prod.uso.join(', ')]]
    .filter(s => s[1]).map(s => `<span>${s[0]}: <b>${s[1]}</b></span>`).join('');
  $('#qvAdd').textContent = `Agregar — ${clp(prod.cheap ? 29990 : prod.price)}`;
  qv.classList.add('open'); getGlass(prod);
}
$('#qvPrev').addEventListener('click', () => { qvIdx = (qvIdx - 1 + qvImgs.length) % qvImgs.length; showQvImg(); });
$('#qvNext').addEventListener('click', () => { qvIdx = (qvIdx + 1) % qvImgs.length; showQvImg(); });
function closeQuickView() { stopTryOn(); qv.classList.remove('open'); }
$('#qvClose').addEventListener('click', closeQuickView);
$('#qvOverlay').addEventListener('click', closeQuickView);
$('#qvStopBtn').addEventListener('click', stopTryOn);
$('#qvTry').addEventListener('click', () => startTryOn(qvTarget, qvProd));
$('#qvSize').addEventListener('input', e => TUNE.widthFactor = +e.target.value);
$('#qvY').addEventListener('input', e => TUNE.yOffset = +e.target.value);
$('#qvAdd').addEventListener('click', () => { if (window.solarAddToCart) window.solarAddToCart(qvProd.id); closeQuickView(); if (window.solarOpenCart) window.solarOpenCart(); });

// API pública para app.js (carrito)
window.solarQuickTryOn = (id) => { const p = P.find(x => x.id === id); if (p) openQuickView(p); };
